import { useFlags } from 'launchdarkly-react-client-sdk'

/**
 * Custom hook to check if the panelist tier feature is enabled
 *
 * @returns {boolean} Whether the panelist tier feature flag is enabled
 */
export function usePanelistTierFlag() {
  const flags = useFlags()
  return flags?.usePanelistTier ?? false
}
